import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import StatementsDataGrid from 'components/reports/inventory/StatementsDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import { toast } from 'react-toastify';
import {
  convertQueryParamsIntoObject,
  convertObjectIntoQueryParams,
  convertToUnix,
  convertFromUnix,
} from 'constant/Helpers';
import cloneDeep from 'lodash/cloneDeep';
// actions
import { setLoaderOpenTrue, setLoaderOpenFalse } from 'store/app/AppActions';
// api
import InventoryReportService from 'services/reportsService/InventoryReportService';
// datadog
import { errorLogger } from 'datadog/DDUtils';

const StatementsDamagedReportPage = () => {
  const [data, setData] = useState([]);
  const [inputValues, setInputValues] = useState({
    fromDate: convertToUnix(),
    toDate: convertToUnix(),
    type: -1,
    transtype: 2,
    isdeliverydate: 0,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setLoaderOpenTrue());
    try {
      const res = await InventoryReportService.getInventoryStatementsReport(params);
      setData(res.data);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Statements Damaged Report Page Fetch Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  const exportFile = async () => {
    try {
      const updatedParams = cloneDeep(inputValues);
      updatedParams.fromDate = convertFromUnix(inputValues.fromDate);
      updatedParams.toDate = convertFromUnix(inputValues.toDate);
      setInputValues(updatedParams);
      const res = await InventoryReportService.exportInventoryStatementsReport(updatedParams);
      toast.success(res?.data?.message);
    } catch (err) {
      errorLogger('Statements Damaged Report Page Export Data Error:', err);
      toast.error('Failed to export report data!!');
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
      setInputValues(queryObj);
    } else {
      fetchData(inputValues);
    }
  }, []);

  const handleSubmit = async () => {
    const updatedParams = cloneDeep(inputValues);
    updatedParams.fromDate = convertFromUnix(inputValues.fromDate);
    updatedParams.toDate = convertFromUnix(inputValues.toDate);
    const queryString = convertObjectIntoQueryParams(updatedParams);
    navigate({
      pathname: '/report/InventoryStatementsDamagedReport',
      search: queryString,
    });
    fetchData(updatedParams);
  };

  return (
    <div className="toolbar-table-style">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        title="Statements (Damaged)"
        dateType
        hasExport
        handleExport={exportFile}
      />
      <StatementsDataGrid data={data} />
    </div>
  );
};

export default StatementsDamagedReportPage;
